export default {"src":"/pro/_next/static/media/eurusd.58784d38.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};